import { Flex, Link, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { MenuSubItem } from 'src/components/enterprise/navigation/NavMenu/MenuSubItem';
import { IMenuItemsConfig } from 'src/components/enterprise/navigation/Navigation';
import { RouterLink } from 'src/components/RouterLink/RouterLink';
import { MenuItemContent } from 'src/components/enterprise/navigation/NavMenu/MenuItemContent';

export function MenuItem({
  subRoutes,
  menu,
  mainRoute,
  hide,
  icon,
  matchingPathnames,
  useRouterLink,
}: IMenuItemsConfig): JSX.Element {
  const { pathname, search } = useLocation();
  const asPath = pathname + search;

  function routeMatchesModule(): boolean {
    if (subRoutes && subRoutes.length > 0) {
      return subRoutes.some((p) => asPath === p.path);
    }

    if (Array.isArray(matchingPathnames)) {
      return matchingPathnames.some((p) => pathname.indexOf(p) === 0);
    }

    return asPath === mainRoute;
  }

  return !hide ? (
    <Stack
      aria-label="menu-item"
      className="navMenu_menuItem"
      borderBottomColor={routeMatchesModule() ? 'interactive' : undefined}
    >
      {useRouterLink ? (
        <RouterLink href={mainRoute}>
          <MenuItemContent
            menu={menu}
            icon={icon}
            hasSubRoutes={!!subRoutes?.length}
          />
        </RouterLink>
      ) : (
        <Link href={mainRoute}>
          <MenuItemContent
            menu={menu}
            icon={icon}
            hasSubRoutes={!!subRoutes?.length}
          />
        </Link>
      )}

      {subRoutes && subRoutes.length > 0 && (
        <Flex
          className="navMenu_subMenuItem"
          position="absolute"
          flexDirection="column"
          dimension="1"
          width="200px"
        >
          {subRoutes.map((m) => (
            <MenuSubItem
              key={m.text}
              text={m.text}
              href={m.path}
              useRouterLink={m.useRouterLink}
              copyColor="secondaryText"
              hide={m.hide}
              badgeLabel={m.badgeLabel}
              badgeFlavor={m.badgeFlavor}
            />
          ))}
        </Flex>
      )}
    </Stack>
  ) : null;
}
